import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createFormRequest = {};
var _createFormResponse = {};
var _deleteFormRequest = {};
var _deleteFormResponse = {};
var _getFormRequest = {};
var _getFormResponse = {};
var _listFormsRequest = {};
var _listFormsResponse = {};
var _updateFormRequest = {};
var _updateFormResponse = {};
function resolveComWixpressBookingsServicesApiV1FormsServiceUrl(opts) {
    var domainToMappings = {
        'bookings._base_domain_': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
        ],
        _api_base_domain_: [
            {
                srcPath: '/services-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/services-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/bookings/v1/forms',
                destPath: '/v1/forms',
            },
            {
                srcPath: '/bookings/v1/services',
                destPath: '/v1/services',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
            {
                srcPath: '/_api/bookings/v1/services/batch',
                destPath: '/v1/services/batch',
            },
            {
                srcPath: '/_api/bookings/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Gets a form
 * > **Permissions**
 * > This endpoint requires the Read Bookings - Public Data or Read Bookings - Including Participants permissions scope
 */
export function get(payload) {
    var _a = serializer(_getFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormResponse, {}).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.form',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.services.api.v1.FormsService.Get',
            url: resolveComWixpressBookingsServicesApiV1FormsServiceUrl({
                protoPath: '/v1/forms/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressBookingsServicesApiV1FormsServiceUrl({
                        protoPath: '/v1/forms/{id}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
/**
 * List all forms
 * > **Permissions**
 * > This endpoint requires the Read Forms - Public Data or Read Bookings - Including Participants permissions scope
 */
export function list(payload) {
    var _a = serializer(_listFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFormsResponse, {}).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.form',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.services.api.v1.FormsService.List',
            url: resolveComWixpressBookingsServicesApiV1FormsServiceUrl({
                protoPath: '/v1/forms/all',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/** Creates a form. */
export function create(payload) {
    var _a = serializer(_createFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFormResponse, {}).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.form',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.services.api.v1.FormsService.Create',
            url: resolveComWixpressBookingsServicesApiV1FormsServiceUrl({
                protoPath: '/v1/forms',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/** Updates a form. */
export function update(payload) {
    var _a = serializer(_updateFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFormResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.form',
            method: 'PUT',
            methodFqn: 'com.wixpress.bookings.services.api.v1.FormsService.Update',
            url: resolveComWixpressBookingsServicesApiV1FormsServiceUrl({
                protoPath: '/v1/forms',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Delete a form */
export function _delete(payload) {
    var _a = serializer(_deleteFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFormResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.form',
            method: 'DELETE',
            methodFqn: 'com.wixpress.bookings.services.api.v1.FormsService._Delete',
            url: resolveComWixpressBookingsServicesApiV1FormsServiceUrl({
                protoPath: '/v1/forms/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
//# sourceMappingURL=http.impl.js.map